export const routes = {
  auth: `/auth`,
  login: `/login`,
  main: `/`,
  errorPage: `/errorPage`,
};
